// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{ count: NonNullable<unknown> }} i
*/
export const guestList_waitlistCount = (i) => `Waitlist (${i.count})`